import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsAddPhotoClickedParams = {
  trail_id?: number;
};

/**
 * A user clicks the 'Add photos' icon/CTA on the trail details page.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsAddPhotoClicked = ({ trail_id }: logTrailDetailsAddPhotoClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details add photo clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsAddPhotoClicked;
